import React, { useState, useEffect, useRef, useMemo } from 'react';
import { Form, Row, Col, Button } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import DatePicker from 'react-datepicker';
import Swal from 'sweetalert2';
import { State, City } from "country-state-city";
import { EditQuotationAPI, fatchQuotationAPI } from '../../redux/actionCreation';
import Select from "react-select";
import Loader from '../Loader';

const chargesConfig = [
    { key: 'transportation', label: 'Transportation Charge' },
    { key: 'packing', label: 'Packing Charge' },
    { key: 'unpacking', label: 'Unpacking Charge' },
    { key: 'loading', label: 'Loading Charge' },
    { key: 'unloading', label: 'Unloading Charge' },
    { key: 'insurance', label: 'Insurance Charge' },
    { key: 'storage', label: 'Storage Charge' },
    { key: 'service', label: 'Service Charge' },
    { key: 'other', label: 'Other Charge' },
];

const QuoteEditPop = ({ QuoteId, allData }) => {
    const dispatch = useDispatch();
    const closeBtnRef = useRef(null);
    const [loading_update, setLoading_update] = useState(false);
    const error_edit = useSelector(state => state.EditQuotationReducers.error?.edit_quotation_errors) ?? null;

// 1. Initial states ko khali rakhein, useEffect se bharenge
const [includeCharge, setIncludeCharge] = useState({});
const [formDatainclude, setFormDatainclude] = useState({});

const [formData, setFormData] = useState({
    name: '', phone_number: '', quotation_date: new Date(),
    customer_address: '', service_name: '', c_gst: '',
    from_state: '', from_city: '', from_address: '',
    to_state: '', to_city: '', to_address: '',
    shift_start_date: new Date(), shift_end_date: new Date(),
    select_floor: '', select_lift: '', select_to_floor: '', select_to_lift: '',
    shift_items: '', transportation_charge: 0, packing_charge: 0,
    unpacking_charge: 0, loading_charge: 0, unloading_charge: 0,
    insurance_charge: 0, service_charge: 0, storage_charge: 0,
    other_charge: 0, total_charge: 0, sgst_per: 0, sgst_charge: 0,
    cgst_per: 0, cgst_charge: 0, gst_per: 0, gst_charge: 0,
});

// Function to format date safely for Input fields
const formatForInput = (dateStr) => {
    if (!dateStr || dateStr === "NA" || dateStr === "0000-00-00") return ""; // Khali string bhejein taaki error_edit na aaye
    
    const date = new Date(dateStr);
    if (isNaN(date.getTime())) return ""; // Agar invalid date hai toh khali string
    
    return date.toISOString().split('T')[0]; // Return YYYY-MM-DD
};

// 2. Refresh aur Data Loading ke liye useEffect
useEffect(() => {
    if (QuoteId && allData && allData.length > 0) {
        const selectedQuote = allData.find(q => q.id === QuoteId);

        if (selectedQuote) {
            // FIX: Yahan dates ko format karke set karein
            setFormData({
                ...selectedQuote,
                shift_start_date: selectedQuote.shift_start_date === "NA" ? "" : selectedQuote.shift_start_date,
                shift_end_date: selectedQuote.shift_end_date === "NA" ? "" : selectedQuote.shift_end_date,
            });

            const updatedIncludes = {};
            const updatedChargeValues = {};

            chargesConfig.forEach(item => {
                const val = selectedQuote[`${item.key}_charge`];

                if (val !== undefined && val !== null && val !== "Included" && val !== 0 && val !== "0" && val !== "") {
                    updatedIncludes[item.key] = false;
                    updatedChargeValues[`${item.key}_charge`] = val;
                } else {
                    updatedIncludes[item.key] = true;
                    updatedChargeValues[`${item.key}_charge`] = '0';
                }
            });

            setIncludeCharge(updatedIncludes);
            setFormDatainclude(updatedChargeValues);
        }
    }
}, [QuoteId, allData]);

    // 3. Checkbox toggle logic
    const handleIncludeToggle = (key) => (e) => {
        const checked = e.target.checked;
        setIncludeCharge(prev => ({ ...prev, [key]: checked }));
        setFormDatainclude(prev => ({
            ...prev,
            [`${key}_charge`]: checked ? '0' : '', 
        }));
    };

    // 4. Input field change logic
    const handleChangeCharge = (e) => {
        const { name, value } = e.target;
        if (!/^\d*$/.test(value)) return;

        const key = name.replace('_charge', '');
        if (!includeCharge[key]) {
            setFormDatainclude(prev => ({ ...prev, [name]: value }));
        }
    };

    // Populate Data
    useEffect(() => {
        if (QuoteId && allData) {
            const selectedQuote = allData.find(q => q.id === QuoteId);
            if (selectedQuote) {
                setFormData({
                    ...selectedQuote,
                    quotation_date: selectedQuote.quotation_date ? new Date(selectedQuote.quotation_date) : new Date(),
                    shift_start_date: selectedQuote.shift_start_date ? new Date(selectedQuote.shift_start_date) : new Date(),
                    shift_end_date: selectedQuote.shift_end_date ? new Date(selectedQuote.shift_end_date) : new Date(),
                });
            }
        }
    }, [QuoteId, allData]);


    // Calculation Function
    const calculateTotal = () => {
        // Base amount jo 'formData' mein hai
        let total = parseFloat(formData.enter_total_amt) || 0;
        console.log("enter am",total);
        // Baaki charges jo dynamic hain 'formDatainclude' se loop karke add honge
        chargesConfig.forEach(({ key }) => {
            const fieldName = `${key}_charge`;
            const val = parseFloat(formDatainclude[fieldName]) || 0;
            total += val;
        });
    
        return total;
    };
    
    // 2. useEffect: Jaise hi koi bhi input change ho, total apne aap update ho jaye
    useEffect(() => {
        const finalTotal = calculateTotal();
        
        // Agar aap total ko formData state mein save karna chahte hain:
        setFormData(prev => ({
            ...prev,
            total: finalTotal
        }));
    }, [formData.enter_total_amt, formDatainclude]); // In dono states ke badalne par chalega

    // Variable bana lete hain taaki code saaf dikhe
    const isGstEnabled = formData.gst_hide_show === "GST Charge Show" || formData.gst_hide_show === "GST Included in Freight Charge";
    
    useEffect(() => {
      const total = calculateTotal(); 
      
      let gstCharge = 0;
      let cgstCharge = 0;
      let sgstCharge = 0;
      let igstCharge = 0;
    
      // Condition 1: Agar "GST Charge Show" hai toh calculate karo
      if (formData.gst_hide_show === "GST Charge Show") {
        const gstPer = parseFloat(formData.gst_per) || 0;
        gstCharge = (total * gstPer) / 100;
    
        if (formData.gst_type === "CGST/SGST") {
          cgstCharge = gstCharge / 2;
          sgstCharge = gstCharge / 2;
        } else {
          igstCharge = gstCharge;
        }
      } 
      // Condition 2: Agar "Included" hai, toh Type/Percent state mein rahega par Charge 0 rahega
      else if (formData.gst_hide_show === "GST Included in Freight Charge") {
        gstCharge = 0;
        cgstCharge = 0;
        sgstCharge = 0;
        igstCharge = 0;
        // Note: Yahan hum calculate nahi kar rahe kyunki wo price mein already include hai
      }
      // Condition 3: Without GST
      else {
        gstCharge = 0;
        cgstCharge = 0;
        sgstCharge = 0;
        igstCharge = 0;
      }
    
      const finalAmount = total + gstCharge;
    
      setFormData((prevData) => ({
        ...prevData,
        total_charge: total.toFixed(2),
        total_gst_charge: gstCharge.toFixed(2),
        cgst_charge: cgstCharge.toFixed(2),
        sgst_charge: sgstCharge.toFixed(2),
        igst_charge: igstCharge.toFixed(2),
        total_amount: finalAmount.toFixed(2),
      }));
    
    }, [
      formData.enter_total_amt,
      formDatainclude,
      formData.gst_hide_show,
      formData.gst_type,
      formData.gst_per,
    ]);
      
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    // const handleUpdate = async (e) => {
    //     e.preventDefault();
    //     setLoading_update(true);
    //     const res = await dispatch(EditQuotationAPI(formData, QuoteId));
    //     if (res?.type === "ADD_DATA_SUCCESS_EDIT_QUOTATION") {
    //         closeBtnRef.current.click();
    //         Swal.fire({ icon: 'success', title: 'Updated!' });
    //         dispatch(fatchQuotationAPI());
    //     }
    //     setLoading_update(false);
    // };

const handleUpdate = async (e) => {
    if (e) e.preventDefault();
    setLoading_update(true);

    // 1. Helper: Date ko safely string mein badalne ke liye (Rangeerror_edit Fix)
    const formatDateForDB = (dateVal) => {
        // Agar date null, undefined, "NA" ya khali string hai
        if (!dateVal || dateVal === "NA" || dateVal === "") return "NA";
        
        const d = new Date(dateVal);
        
        // Check if Date object is valid before calling any methods
        if (isNaN(d.getTime())) return "NA";
        
        try {
            // Safe format: YYYY-MM-DD
            const year = d.getFullYear();
            const month = String(d.getMonth() + 1).padStart(2, '0');
            const day = String(d.getDate()).padStart(2, '0');
            return `${year}-${month}-${day}`;
        } catch (err) {
            console.error("Date formatting error:", err);
            return "NA";
        }
    };

    // 2. Charges Logic: Checkbox ke hisaab se values set karein
    const finalCharges = {};
    chargesConfig.forEach(item => {
        const key = `${item.key}_charge`;
        // Agar checkbox checked hai toh "Included", varna numeric value
        finalCharges[key] = includeCharge[item.key] ? "Included" : (formDatainclude[key] || "0");
    });

    // 3. Sab kuch merge karein
    const updatedData = {
        ...formData,
        ...finalCharges,
        // Teeno dates ko safely convert karein
        quotation_date: formatDateForDB(formData.quotation_date),
        shift_start_date: formatDateForDB(formData.shift_start_date),
        shift_end_date: formatDateForDB(formData.shift_end_date),
    };

    // 4. API Dispatch
    try {
        const res = await dispatch(EditQuotationAPI(updatedData, QuoteId));

        if (res?.type === "ADD_DATA_SUCCESS_EDIT_QUOTATION") {
            if (closeBtnRef.current) closeBtnRef.current.click();
            
            Swal.fire({ 
                icon: 'success',
                title: 'Quotation Updated Successfully!', 
                showConfirmButton: true,
                timer: 1500 
            });

            // List refresh karein
            dispatch(fatchQuotationAPI());
        } else {
            Swal.fire({ icon: 'error', title: 'Update Failed!', text: 'Please try again.' });
        }
    } catch (error) {
        console.error("Update Error:", error);
        Swal.fire({ icon: 'error', title: 'Error', text: 'Something went wrong!' });
    } finally {
        setLoading_update(false);
    }
};

 // State for From Location

 // State for From Location
// --- 1. State Variables ---
const [selectedState, setSelectedState] = useState(null);
const [selectedCity, setSelectedCity] = useState(null);
const [cities, setCities] = useState([]);

const [selectedToState, setSelectedToState] = useState(null);
const [selectedToCity, setSelectedToCity] = useState(null);
const [toCities, setToCities] = useState([]);

// --- 2. States Array (Value = Name for DB, isoCode for filtering) ---
const states = useMemo(() => State.getStatesOfCountry("IN").map((state) => ({
    value: state.name,     // DB mein "Gujarat" jayega
    label: state.name,     // UI mein "Gujarat" dikhega
    isoCode: state.isoCode // City load karne ke liye
})), []);

// --- 3. Load Data when Editing (From Location) ---
useEffect(() => {
    if (formData.from_state) {
        const stateObj = states.find(s => s.value === formData.from_state || s.isoCode === formData.from_state);
        if (stateObj) {
            setSelectedState(stateObj);
            const filteredCities = City.getCitiesOfState("IN", stateObj.isoCode).map(city => ({
                value: city.name,
                label: city.name
            }));
            setCities(filteredCities);
            if (formData.from_city) {
                const cityObj = filteredCities.find(c => c.value === formData.from_city);
                setSelectedCity(cityObj || { value: formData.from_city, label: formData.from_city });
            }
        }
    }
}, [formData.from_state, states]);

// --- 4. Load Data when Editing (To Location) ---
useEffect(() => {
    if (formData.to_state) {
        const stateObj = states.find(s => s.value === formData.to_state || s.isoCode === formData.to_state);
        if (stateObj) {
            setSelectedToState(stateObj);
            const filteredCities = City.getCitiesOfState("IN", stateObj.isoCode).map(city => ({
                value: city.name,
                label: city.name
            }));
            setToCities(filteredCities);
            if (formData.to_city) {
                const cityObj = filteredCities.find(c => c.value === formData.to_city);
                setSelectedToCity(cityObj || { value: formData.to_city, label: formData.to_city });
            }
        }
    }
}, [formData.to_state, states]);

// --- 5. Handlers ---
const handleStateChange = (selectedOption) => {
    setSelectedState(selectedOption);
    setSelectedCity(null);
    setFormData(prev => ({ ...prev, from_state: selectedOption?.value || "", from_city: "" }));
    if (selectedOption) {
        setCities(City.getCitiesOfState("IN", selectedOption.isoCode).map(c => ({ value: c.name, label: c.name })));
    }
};

const handleToStateChange = (selectedOption) => {
    setSelectedToState(selectedOption);
    setSelectedToCity(null);
    setFormData(prev => ({ ...prev, to_state: selectedOption?.value || "", to_city: "" }));
    if (selectedOption) {
        setToCities(City.getCitiesOfState("IN", selectedOption.isoCode).map(c => ({ value: c.name, label: c.name })));
    }
};

const handleCityChange = (selectedOption) => {
    setSelectedCity(selectedOption);
    setFormData(prev => ({ ...prev, from_city: selectedOption?.value || "" }));
};

const handleToCityChange = (selectedOption) => {
    setSelectedToCity(selectedOption);
    setFormData(prev => ({ ...prev, to_city: selectedOption?.value || "" }));
};

 
    //       // Function to calculate total of specified fields
    //  const calculateTotal = () => {
    //   const {
    //     transportation_charge,
    //     packing_charge,
    //     unpacking_charge,
    //     loading_charge,
    //     unloading_charge,
    //     insurance_charge,
    //     storage_charge,
    //     other_charge
    //   } = formData;
  
    //   const total =
    //     parseFloat(transportation_charge) +
    //     parseFloat(packing_charge) +
    //     parseFloat(unpacking_charge) +
    //     parseFloat(loading_charge) +
    //     parseFloat(unloading_charge) +
    //     parseFloat(insurance_charge) +
    //     parseFloat(storage_charge) +
    //     parseFloat(other_charge);
    //   return total;
    // };
  
    //   // Function to calculate SGST charge based on total and cgst_per
    //   const calculateSGSTCharge = (total, sgstPercentage) => {
    //       return (total * parseFloat(sgstPercentage)) / 100;
    //   };
  
    //   // Function to calculate CGST charge based on total and cgst_per
    //   const calculateCGSTCharge = (total, cgstPercentage) => {
    //       return (total * parseFloat(cgstPercentage)) / 100;
    //   };
      
    //   // Function to calculate IGST charge based on total and gst_per
    //   const calculateGSTCharge = (total, gstPercentage) => {
    //       return (total * parseFloat(gstPercentage)) / 100;
    //   };
    
    //   // useEffect to watch for changes in relevant fields and recalculate charges
    //   useEffect(() => {
    //       const total = calculateTotal();
    //       const gstCharge = calculateGSTCharge(total, formData.gst_per);
    //       const cgstCharge = calculateCGSTCharge(total, formData.cgst_per);
    //       const sgstCharge = calculateSGSTCharge(total, formData.sgst_per);
    //       // Update state with the calculated values
    //       setFormData((prevData) => ({
    //       ...prevData,
    //       total_charge:total.toFixed(2),
    //       gst_charge: gstCharge.toFixed(2), // Adjust decimal places as needed
    //       cgst_charge: cgstCharge.toFixed(2), // Adjust decimal places as needed
    //       sgst_charge: sgstCharge.toFixed(2), // Adjust decimal places as needed
    //       }));
    //   }, [
    //       formData.transportation_charge,
    //       formData.packing_charge,
    //       formData.unpacking_charge,
    //       formData.loading_charge,
    //       formData.unloading_charge,
    //       formData.insurance_charge,
    //       formData.storage_charge,
    //       formData.other_charge,
    //       formData.sgst_per,
    //       formData.cgst_per,
    //       formData.gst_per,
    //   ]);
    

  const handleQuoteDateChange = (date) => {
          const modifiedDate = new Date(date);
          modifiedDate.setHours(0, 0, 0, 0);
          // Format the date to "dd-mm-yyyy"
          const day = String(modifiedDate.getDate()).padStart(2, '0');
          const month = String(modifiedDate.getMonth() + 1).padStart(2, '0'); // Months are zero-based
          const year = String(modifiedDate.getFullYear());
      
          const formattedDate = `${day}-${month}-${year}`;
          console.log("date", formattedDate);
          // Update the recipts_date field in formData when the DatePicker changes
          setFormData((prevState) => ({
              ...prevState,
              quotation_date: modifiedDate,
          }));
          };
      
        const handleStartDateChange = (date) => {
    // 1. Agar date null ya clear ki gayi hai
    if (!date || date === "NA") {
        setFormData(prev => ({ 
            ...prev, 
            shift_start_date: "",
            // Optional: Agar start date clear ho toh end date bhi clear karni ho toh
            // shift_end_date: "" 
        }));
        return;
    }

    try {
        const modifiedDate = new Date(date);
        if (isNaN(modifiedDate.getTime())) {
            setFormData(prev => ({ ...prev, shift_start_date: "" }));
            return;
        }

        modifiedDate.setHours(0, 0, 0, 0);

        setFormData((prevState) => {
            // Check logic: Agar End Date pehle se khali hai, 
            // YA End Date aur Start Date pehle se same the (matlab user ne End date manually change nahi ki thi)
            // Tabhi hum dono ko update karenge.
            
            const shouldUpdateEndDate = !prevState.shift_end_date || 
                                       prevState.shift_end_date === "NA" || 
                                       prevState.shift_end_date === "" ||
                                       new Date(prevState.shift_end_date).getTime() === new Date(prevState.shift_start_date).getTime();

            return {
                ...prevState,
                shift_start_date: modifiedDate,
                shift_end_date: shouldUpdateEndDate ? modifiedDate : prevState.shift_end_date
            };
        });

    } catch (error) {
        console.error("Start Date Error:", error);
        setFormData(prev => ({ ...prev, shift_start_date: "" }));
    }
};
            const handleEndDateChange = (date) => {
                if (!date || date === "NA") {
                    setFormData(prev => ({ ...prev, shift_end_date: "" }));
                    return;
                }

                try {
                    const modifiedDate = new Date(date);
                    if (isNaN(modifiedDate.getTime())) {
                        setFormData(prev => ({ ...prev, shift_end_date: "" }));
                        return;
                    }

                    modifiedDate.setHours(0, 0, 0, 0);
                    setFormData(prev => ({ ...prev, shift_end_date: modifiedDate }));
                } catch (error) {
                    console.error("End Date Error:", error);
                    setFormData(prev => ({ ...prev, shift_end_date: "" }));
                }
            };

        // const handleStartDateChange = (date) => {
        //   const modifiedDate = new Date(date);
        //   modifiedDate.setHours(0, 0, 0, 0);
        //   // Format the date to "dd-mm-yyyy"
        //   const day = String(modifiedDate.getDate()).padStart(2, '0');
        //   const month = String(modifiedDate.getMonth() + 1).padStart(2, '0'); // Months are zero-based
        //   const year = String(modifiedDate.getFullYear());
      
        //   const formattedDate = `${day}-${month}-${year}`;
        //   console.log("date", formattedDate);
        //   // Update the recipts_date field in formData when the DatePicker changes
        //   setFormData((prevState) => ({
        //       ...prevState,
        //       shift_start_date: modifiedDate,
        //   }));
        // };
      
        // const handleEndDateChange = (date) => {
        //   const modifiedDate = new Date(date);
        //   modifiedDate.setHours(0, 0, 0, 0);
        //   // Format the date to "dd-mm-yyyy"
        //   const day = String(modifiedDate.getDate()).padStart(2, '0');
        //   const month = String(modifiedDate.getMonth() + 1).padStart(2, '0'); // Months are zero-based
        //   const year = String(modifiedDate.getFullYear());
      
        //   const formattedDate = `${day}-${month}-${year}`;
        //   console.log("date", formattedDate);
        //   // Update the recipts_date field in formData when the DatePicker changes
        //   setFormData((prevState) => ({
        //       ...prevState,
        //       shift_end_date: modifiedDate,
        //   }));
        // };
  

    return (
        <div class="offcanvas offcanvas-start" data-bs-backdrop="static" tabIndex="-1" id="staticBackdropQuote" aria-labelledby="staticBackdropLabel" style={{ zIndex: 99999999999 }}>
                <div class="offcanvas-header bg-info">
                    <h5 class="offcanvas-title text-white" id="staticBackdropLabel2">Edit Quotation</h5>
                    <button type="button" ref={closeBtnRef} class="btn-close btn-close2" data-bs-dismiss="offcanvas" aria-label="Close"></button>
                </div>
                
                <div class="offcanvas-body">
                    <div>
                        <Form onSubmit={handleUpdate}>
                            <Row className="mb-3">
                            <h6 className='mb-0'>General Details:</h6>
                                <Col xs="12" sm="12" md="12" lg="12" xl="12" xxl="12">
                                    <hr className='w-10'/>
                                </Col>

                                <Form.Group as={Col} xs="12" sm="12" md="12" lg="12" xl="12" xxl="12" controlId="formGridPassword" className='mt-2'>
                                    <Form.Label>Quotation Date (कोटेशन की तारीख)</Form.Label>
                                        <div className="date-picker-container">
                                                <i className='calendar-icon fa fa-calendar'></i>
                                                <DatePicker
                                                    selected={formData.quotation_date}
                                                    onChange={handleQuoteDateChange}
                                                    dateFormat="dd-MM-yyyy"
                                                    placeholderText="Quotation Date"
                                                    className='form-control'
                                                    required
                                                />
                                            </div>
                                </Form.Group>

                                <Form.Group as={Col} xs="12" sm="12" md="12" lg="12" xl="12" xxl="12" controlId="formGridEmail" className='mt-2'>
                                    <Form.Label>Company / Party Name (नाम - जिसे कोटेशन चाहिए) <span class="text-danger">*</span></Form.Label>
                                        <Form.Control type="text" onChange={handleChange} placeholder="Customer Name.." name="name" value={formData.name} required/>
                                        {error_edit?.name && (
                                        <span className="alert alert-danger d-block mt-1 pt-1 pb-1">
                                            {error_edit.name && error_edit.name}
                                        </span>
                                        )}
                                </Form.Group>

                                <Form.Group as={Col} xs="12" sm="12" md="12" lg="12" xl="12" xxl="12" controlId="formGridPassword" className='mt-2'>
                                        <Form.Label>Phone</Form.Label>
                                            <Form.Control type="number" placeholder="Customer Phone.." onChange={handleChange} name="phone_number" value={formData.phone_number}/>

                                            {error_edit?.phone_greater && (
                                            <span className="alert alert-danger d-block mt-1 pt-1 pb-1">
                                            {error_edit.phone_greater && error_edit.phone_greater}
                                            </span>
                                            )}

                                            {error_edit?.phone_less && (
                                                <span className="alert alert-danger d-block mt-1 pt-1 pb-1">
                                                {error_edit.phone_less && error_edit.phone_less}
                                                </span>
                                            )}
                                </Form.Group>

                                
                                    <Form.Group as={Col} xs="12" sm="12" md="12" lg="12" xl="12" xxl="12" controlId="formGridEmail" className='mt-2'>
                                        <Form.Label>Moving Type (मुविंग के प्रकार) <span class="text-danger">*</span></Form.Label> 
                                        {/* <Form.Control type="text" placeholder="Service Name.." onChange={handleChange} name="service_name" value={formData.service_name} required/> */}
                                        <select className='form-select' id="" onChange={handleChange} name="service_name" value={formData.service_name} required>
                                                    <option value="" disabled>Select Service</option>
                                                    <option value="House Hold Goods">House Hold Goods</option>
                                                    <option value="Local">Local</option>
                                                    <option value="Domestic">Domestic</option>
                                                    <option value="International">International</option>
                                                    <option value="Office Shifting">Office Shifting</option>
                                                    <option value="Industrial Goods Shifting">Industrial Goods Shifting</option>
                                                    <option value="Car Shifting">Car Shifting</option>
                                                    <option value="House Hold Goods And Car Shifting">House Hold Goods And Car Shifting</option>
                                                    <option value="Bike Shifting">Bike Shifting</option>
                                                    <option value="House Hold Goods And Bike Shifting">House Hold Goods And Bike Shifting</option>
                                                    <option value="Car and Bike Shifting">Car and Bike Shifting</option>
                                                    <option value="House Hold Goods, Bike And Car Shifting">House Hold Goods, Bike And Car Shifting</option>
                                                    <option value="Pet Relocation">Pet Relocation</option>
                                                    <option value="House Hold Goods, Bike And Car Shifting, Pet Relocation">House Hold Goods, Bike And Car Shifting, Pet Relocation</option>
                                            </select>
                                    </Form.Group>

                                    <Form.Group as={Col} xs="12" sm="12" md="12" lg="12" xl="12" xxl="12" controlId="formGridEmail" className='mt-3'>
                                             <Form.Label>Party GST No.</Form.Label>
                                             <Form.Control type="text" placeholder="Customer GST No..." onChange={handleChange} name="c_gst" value={formData.c_gst}/>
                                     </Form.Group>                                   
                                    
                                    <Form.Group as={Col} xs="12" sm="12" md="6" lg="6" xl="6" xxl="6" controlId="formGridPassword" className='mt-2'>
                                        <Form.Label>Packing Start Date</Form.Label>
                                            <div className="date-picker-container">
                                                <i className='calendar-icon fa fa-calendar'></i>
                                                <DatePicker
                                                    selected={(() => {
                                                        const d = formData.shift_start_date;
                                                        // Agar date nahi hai, NA hai, ya invalid string hai toh null bhejien
                                                        if (!d || d === "NA" || d === "") return null;
                                                        const parsedDate = new Date(d);
                                                        return isNaN(parsedDate.getTime()) ? null : parsedDate;
                                                    })()}
                                                    onChange={handleStartDateChange}
                                                    dateFormat="dd-MM-yyyy"
                                                    placeholderText="Start Date"
                                                    className='form-control'
                                                    autoComplete="off"
                                                />
                                            </div>
                                        </Form.Group>

                                        <Form.Group as={Col} xs="12" sm="12" md="6" lg="6" xl="6" xxl="6" controlId="formGridPassword" className='mt-2'>
                                            <Form.Label>Moving End Date</Form.Label>
                                            <div className="date-picker-container">
                                                <i className='calendar-icon fa fa-calendar'></i>
                                                    <DatePicker
                                                        selected={(() => {
                                                            const d = formData.shift_end_date;
                                                            if (!d || d === "NA" || d === "") return null;
                                                            const parsedDate = new Date(d);
                                                            return isNaN(parsedDate.getTime()) ? null : parsedDate;
                                                        })()}
                                                        onChange={handleEndDateChange}
                                                        dateFormat="dd-MM-yyyy"
                                                        placeholderText="End Date"
                                                        className='form-control'
                                                        autoComplete="off"
                                                    />
                                            </div>
                                            {error_edit?.shift_end_date_final && (
                                            <span className="alert alert-danger d-block mt-1 mb-1 pt-1 pb-1">
                                                {error_edit.shift_end_date_final && error_edit.shift_end_date_final}
                                            </span>
                                            )}
                                        </Form.Group>

                                <Form.Group as={Col} xs="12" sm="12" md="12" lg="12" xl="12" xxl="12" controlId="exampleForm.ControlTextarea1" className='mt-2'>
                                    <Form.Label>Party Address (पता)</Form.Label>
                                    <Form.Control as="textarea" rows={3} placeholder="Customer Address.." onChange={handleChange} name="customer_address" value={formData.customer_address}/>
                                    </Form.Group>

                                    <h6 className='mb-0 mt-3 p-2 bg-gray'>Move From (जहां से सामान जाएगा):</h6>
                                        <Col xs="12" sm="12" md="12" lg="12" xl="12" xxl="12">
                                            <hr className='w-10'/>
                                        </Col>

                                        {/* FROM STATE */}
                                        <Form.Group as={Col} xs="12" sm="12" md="6" lg="6" xl="6" className="mt-3">
                                            <Form.Label>Select <b>From</b> State</Form.Label>
                                            <Select
                                                id="fromStateSelect"
                                                options={states}
                                                name="from_state"
                                                required
                                                value={selectedState} // Direct state use karein
                                                onChange={handleStateChange}
                                                placeholder="Select State"
                                            />
                                        </Form.Group>

                                        {/* FROM CITY */}
                                        <Form.Group as={Col} xs="12" sm="12" md="6" lg="6" xl="6" className="mt-3">
                                            <Form.Label>Select <b>From</b> City</Form.Label>
                                            <Select
                                                options={cities}
                                                name="from_city"
                                                required
                                                value={selectedCity}
                                                onChange={handleCityChange}
                                                placeholder="Select City"
                                                isDisabled={!selectedState}
                                            />
                                        </Form.Group>

                                        <div className='form-group mt-3 col-md-12 col-lg-12 col-sm-12 col-xs-12'>
                                            <Form.Label for="exampleSelect2"><b>From</b> Select Floor</Form.Label>
                                            <select className='form-select' id="exampleSelect2" onChange={handleChange} name="select_floor" value={formData.select_floor} required>
                                                <option value="" disabled>Floor Select </option>
                                                <option value="Ground Floor">Ground Floor</option>
                                                <option value="1">1</option>
                                                <option value="2">2</option>
                                                <option value="3">3</option>
                                                <option value="4">4</option>
                                                <option value="5">5</option>
                                                <option value="6">6</option>
                                                <option value="7">7</option>
                                                <option value="8">8</option>
                                                <option value="9">9</option>
                                                <option value="10">10</option>
                                                <option value="11">11</option>
                                                <option value="12">12</option>
                                                <option value="13">13</option>
                                                <option value="14">14</option>
                                                <option value="15">15</option>
                                                <option value="16">16</option>
                                                <option value="17">17</option>
                                                <option value="18">18</option>
                                                <option value="19">19</option>
                                                <option value="20">20</option>
                                                <option value="21">21</option>
                                                <option value="22">22</option>
                                                <option value="23">23</option>
                                                <option value="24">24</option>
                                                <option value="25">25</option>
                                                <option value="26">26</option>
                                                <option value="27">27</option>
                                                <option value="28">28</option>
                                                <option value="29">29</option>
                                                <option value="30">30</option>
                                                <option value="30+">30+</option>
                                            </select>
                                        </div>

                                        <Form.Group as={Col} xs="12" sm="12" md="12" lg="12" xl="12" xxl="12" className="mt-3">
                                            <Form.Label><b>From</b> Select Lift Availability</Form.Label>
                                            <div>
                                            <Form.Check 
                                                type="radio"
                                                label="Service Lift"
                                                name="select_lift"    // Updated name attribute
                                                value="From Service Lift"
                                                id="service Lift"
                                                onChange={handleChange}
                                                checked={formData.select_lift === "From Service Lift"}
                                                inline
                                                required
                                            />
                                            <Form.Check 
                                                type="radio"
                                                label="Passenger Lift"
                                                name="select_lift"    // Updated name attribute
                                                value="From Passenger Lift"
                                                id="passenger_lift"
                                                onChange={handleChange}
                                                checked={formData.select_lift === "From Passenger Lift"}
                                                inline
                                            />
                                            <Form.Check 
                                                type="radio"
                                                label="Stairs"
                                                name="select_lift"    // Updated name attribute
                                                value="From Stairs"
                                                id="stairs"
                                                onChange={handleChange}
                                                checked={formData.select_lift === "From Stairs"}
                                                inline
                                            />
                                        </div>
                                        </Form.Group>

                                            
                                        <Form.Group as={Col} xs="12" sm="12" md="12" lg="12" xl="12" controlId="exampleForm.ControlTextarea1" className='mt-3'>
                                            <Form.Label><b>From</b> Address</Form.Label>
                                            <Form.Control as="textarea" rows={3} placeholder="Customer Address.." onChange={handleChange} name="from_address" 
                                            value={formData.from_address}
                                            />
                                        </Form.Group>

                                        <h6 className='mb-0 mt-3 p-2 bg-gray'>Move To (जहां सामान जाना है):</h6>

                                        {/* TO STATE */}
                                            <Form.Group as={Col} xs="12" sm="12" md="6" lg="6" xl="6" className="mt-3">
                                                <Form.Label>Select <b>To</b> State</Form.Label>
                                                <Select
                                                    id="toStateSelect"
                                                    options={states}
                                                    name="to_state"
                                                    required
                                                    value={selectedToState}
                                                    onChange={handleToStateChange}
                                                    placeholder="Select State"
                                                />
                                            </Form.Group>

                                            {/* TO CITY */}
                                            <Form.Group as={Col} xs="12" sm="12" md="6" lg="6" xl="6" className="mt-3">
                                                <Form.Label>Select <b>To</b> City</Form.Label>
                                                <Select
                                                    options={toCities}
                                                    name="to_city"
                                                    required
                                                    value={selectedToCity}
                                                    onChange={handleToCityChange}
                                                    placeholder="Select City"
                                                    isDisabled={!selectedToState}
                                                />
                                            </Form.Group>

                                        <div className='form-group mt-3 col-md-12 col-lg-12 col-sm-12 col-xs-12'>
                                            <Form.Label for="exampleSelect2"><b>To</b> Select Floor</Form.Label>
                                            <select className='form-select' id="exampleSelect2" onChange={handleChange} name="select_to_floor" value={formData.select_to_floor} required>
                                                <option value="" disabled>From Floor Select </option>
                                                <option value="Ground Floor">Ground Floor</option>
                                                <option value="1">1</option>
                                                <option value="2">2</option>
                                                <option value="3">3</option>
                                                <option value="4">4</option>
                                                <option value="5">5</option>
                                                <option value="6">6</option>
                                                <option value="7">7</option>
                                                <option value="8">8</option>
                                                <option value="9">9</option>
                                                <option value="10">10</option>
                                                <option value="11">11</option>
                                                <option value="12">12</option>
                                                <option value="13">13</option>
                                                <option value="14">14</option>
                                                <option value="15">15</option>
                                                <option value="16">16</option>
                                                <option value="17">17</option>
                                                <option value="18">18</option>
                                                <option value="19">19</option>
                                                <option value="20">20</option>
                                                <option value="21">21</option>
                                                <option value="22">22</option>
                                                <option value="23">23</option>
                                                <option value="24">24</option>
                                                <option value="25">25</option>
                                                <option value="26">26</option>
                                                <option value="27">27</option>
                                                <option value="28">28</option>
                                                <option value="29">29</option>
                                                <option value="30">30</option>
                                                <option value="30+">30+</option>
                                            </select>
                                        </div>

                                        <Form.Group as={Col} xs="12" sm="12" md="12" lg="12" xl="12" xxl="12" className="mt-3">
                                            <Form.Label><b>To</b> Select  Lift Availability <span className="text-danger">*</span></Form.Label>
                                            <div>
                                            <Form.Check 
                                                type="radio"
                                                label="Service Lift"
                                                name="select_to_lift"    // Updated name attribute
                                                value="To Service Lift"
                                                id="Service Lift"
                                                onChange={handleChange}
                                                checked={formData.select_to_lift === "To Service Lift"}
                                                inline
                                                required
                                            />
                                            <Form.Check 
                                                type="radio"
                                                label="Passenger Lift"
                                                name="select_to_lift"    // Updated name attribute
                                                value="To Passenger Lift"
                                                id="Passenger to Lift"
                                                onChange={handleChange}
                                                checked={formData.select_to_lift === "To Passenger Lift"}
                                                inline
                                            />

                                            <Form.Check 
                                                type="radio"
                                                label="Stairs"
                                                name="select_to_lift"    // Updated name attribute
                                                value="To Stairs"
                                                id="stairs_to"
                                                onChange={handleChange}
                                                checked={formData.select_to_lift === "To Stairs"}
                                                inline
                                            />
                                        </div>
                                        </Form.Group>


                                        <Form.Group as={Col} xs="12" sm="12" md="12" lg="12" xl="12" controlId="exampleForm.ControlTextarea1" className='mt-3'>
                                            <Form.Label><b>To</b> Address</Form.Label>
                                            <Form.Control as="textarea" rows={3} placeholder="Customer Address.." onChange={handleChange} name="to_address" value={formData.to_address}/>
                                        </Form.Group>

                                        {/* <Form.Group as={Col} xs="12" sm="12" md="6" lg="6" xl="6" xxl="6" controlId="formGridEmail" className='mt-2'>
                                            <Form.Label>From City/Area</Form.Label>
                                            <Form.Control type="text" placeholder="From.." onChange={handleChange} name="from_city" value={formData.from_city} required/>
                                        </Form.Group>

                                        <Form.Group as={Col} xs="12" sm="12" md="6" lg="6" xl="6" xxl="6" controlId="formGridEmail" className='mt-2'>
                                            <Form.Label>To City/Area</Form.Label>
                                            <Form.Control type="text" placeholder="To.." onChange={handleChange} name="to_city" value={formData.to_city} required/>
                                        </Form.Group> */}

                                            <Form.Group as={Col} xs="12" sm="12" md="12" lg="12" xl="12" xxl="12" controlId="exampleForm.ControlTextarea1" className='mt-2'>
                                                <Form.Label>Shifting Items</Form.Label>
                                                <Form.Control as="textarea" rows={3} placeholder="Shifting Items.." onChange={handleChange} name="shift_items" value={formData.shift_items}/>
                                            </Form.Group>

                                            <h6 className='mb-0 mt-3 p-2 bg-gray'>Shifting Charges :</h6>
                                            <Col xs="12" sm="12" md="12" lg="12" xl="12" xxl="12">
                                                <hr className='w-10'/>
                                            </Col>

                                             <Form.Group as={Col} xs="12" sm="12" md="12" lg="12" xl="12" xxl="12" controlId="formGridPassword" className='mt-3 bg-gray p-3 pb-4'>
                                                    <Form.Label>Total Amount (पार्टी से तय कुल राशि)<span class="text-danger">*</span></Form.Label>
                                                    <Form.Control 
                                                      type="number" 
                                                      min={0} 
                                                      placeholder="Total Amount.." 
                                                      name="enter_total_amt" 
                                                      value={formData.enter_total_amt || ''} // State se value connect karein
                                                      onChange={handleChange}               // onChange handler lagayein
                                                      required 
                                                  />
                                            </Form.Group>
                                                                                    
                                                                                    
                                            <Col xs="12" sm="12" md="12" lg="12" xl="12" xxl="12">
                                                <span className="mb-0 mt-3 d-block">
                                                    यदि नीचे दिए गए सभी चार्ज कुल राशि में शामिल हैं, तो <strong className="text-primary">Include in Total</strong> पर टिक रहने दें। अन्यथा, उस पर से टिक हटाकर आप चार्ज जोड़ सकते हैं।{' '}
                                                 </span>
                                                <hr className="w-10" />
                                            </Col> 

                                            {chargesConfig.map(({ key, label }) => (
                                                    <Form.Group as={Col} xs="12" sm="12" md="12" lg="12" xl="12" xxl="12" className="mt-3" key={key}>
                                                        <div className="d-flex justify-content-between">
                                                           <Form.Label>{label}</Form.Label>
                                                                <Form.Label
                                                                    htmlFor={key}
                                                                    className="px-2 d-flex align-items-center gap-2 rounded-3">
                                                                        <strong className="text-primary">Include in Total</strong>
                                                                            <Form.Check
                                                                                id={key}
                                                                                type="checkbox"
                                                                                checked={includeCharge[key]}
                                                                                onChange={handleIncludeToggle(key)}
                                                                                />
                                                            </Form.Label>
                                                        </div>
                                            
                                                            <Form.Control type="text"   // 👈 number ki jagah text
                                                                inputMode="numeric"
                                                                pattern="[0-9]*"
                                                                placeholder={`${label}..`}
                                                                name={`${key}_charge`}
                                                                value={formDatainclude[`${key}_charge`] ?? ''}
                                                                onChange={handleChangeCharge}
                                                                readOnly={includeCharge[key]}
                                                                className={includeCharge[key] ? 'readonly-input' : ''}
                                                                required/>
                                                            </Form.Group>
                                                 ))}
                                            
                                            <Form.Group as={Col} xs="12" sm="12" md="12" lg="12" xl="12" xxl="12" controlId="formGridPassword" className='mt-2'>
                                                <Form.Label>Sub Total</Form.Label>
                                                <Form.Control className='readonly-input form-control' type="number" placeholder="Total.." name="total_charge" value={calculateTotal()} readOnly/>
                                            </Form.Group>

                                            <h6 className='mb-0 mt-3'>Tax Charges :</h6>
                                            <Col xs="12" sm="12" md="12" lg="12" xl="12" xxl="12">
                                                <hr className='w-10'/>
                                            </Col>
                                            
                                          <div className='form-group mt-3 col-md-12 col-lg-12 col-sm-12 col-xs-12'>
                                            <Form.Label for="exampleSelect2">GST (Show/Hide GST)</Form.Label>
                                            <select className='form-select' id="exampleSelect2" onChange={handleChange} name="gst_hide_show" value={formData.gst_hide_show}>
                                                <option value="GST Charge Show">GST Charge Show</option>
                                                <option value="Without GST Quotation">Without GST Quotation</option>
                                                <option value="GST Included in Freight Charge" selected>GST Included in Freight Charge</option>
                                            </select>
                                            
                                            {error_edit?.gst_hide_show && (
                                            <span className="alert alert-danger d-block mb-1 mt-1 pt-1 pb-1">
                                                {error_edit.gst_hide_show && error_edit.gst_hide_show}
                                            </span>
                                            )}
                                        </div>

                                        <div className='form-group mt-3 col-md-12 col-lg-12 col-sm-12 col-xs-12'>
                                            <Form.Label for="exampleSelect2">GST Type</Form.Label>
                                            <select 
                                                className='form-select' 
                                                name="gst_type" 
                                                onChange={handleChange} 
                                                value={formData.gst_type}
                                                disabled={!isGstEnabled} // Agar Included ya Show hai toh Enable rahega
                                            >
                                                <option value="CGST/SGST">CGST/SGST</option>
                                                <option value="IGST">IGST</option>
                                            </select>
                                            {error_edit?.gst_type && (
                                            <span className="alert alert-danger d-block mb-1 mt-1 pt-1 pb-1">
                                                {error_edit.gst_type && error_edit.gst_type}
                                            </span>
                                            )}
                                        </div>

                                        <div className='form-group mt-3 col-md-6 col-lg-6 col-sm-12 col-xs-12'>
                                            <Form.Label for="exampleSelect2">GST %</Form.Label>
                                                {/* // GST % Select */}
                                                <select 
                                                    className='form-select' 
                                                    name="gst_per" 
                                                    onChange={handleChange} 
                                                    value={formData.gst_per}
                                                    disabled={!isGstEnabled} // Same condition yahan bhi
                                                >
                                                    <option value="" disabled>Select % </option>
                                                    <option value="0">0%</option>
                                                    <option value="5">5%</option>
                                                    <option value="12">12%</option>
                                                    <option value="18">18%</option>
                                                    <option value="28">28%</option>
                                                </select>
                                            {error_edit?.gst_per && (
                                            <span className="alert alert-danger d-block mb-1 mt-1 pt-1 pb-1">
                                                {error_edit.gst_per && error_edit.gst_per}
                                            </span>
                                            )}
                                        </div>

                                        <Form.Group as={Col} xs="12" sm="12" md="6" lg="6" xl="6" xxl="6" controlId="formGridPassword" className='mt-3'>
                                            <Form.Label>GST Charge</Form.Label>
                                            <Form.Control type="number" min={0} className='readonly-input' placeholder="Total GST Charge.." name="total_gst_charge" value={formData.total_gst_charge} readOnly/>
                                        </Form.Group>

                                            {/* <Form.Group as={Col} xs="12" sm="12" md="6" lg="6" xl="6" xxl="6" controlId="formGridPassword" className='mt-2'>
                                                <Form.Label>Service Charge</Form.Label>
                                                <Form.Control type="number" placeholder="Service Charge.." onChange={handleChange} name="service_charge" value={formData.service_charge}/>
                                            </Form.Group> */}

                                            <Form.Group as={Col} xs="12" sm="12" md="12" lg="12" xl="12" xxl="12" controlId="exampleForm.ControlTextarea1" className='mt-3'>
                                                    <Form.Label>Notes (पार्टी की कोई अतिरिक्त जानकारी हो तो यहाँ लिखें…)</Form.Label>
                                                    <Form.Control as="textarea" rows={3} placeholder="Notes.." name="Notes" value={formData.Notes} onChange={handleChange}/>
                                            </Form.Group>
                                        </Row>

                                    <Button variant="primary" type="submit" className='d-flex align-items-center justify-content-center'>
                                    <span className='mx-2'>Update</span>
                                    {loading_update && <span className='spin-sm'><Loader /></span>}
                                </Button>
                        </Form>
                    </div>
                </div>
        </div>
    );
}

export default QuoteEditPop;